import { Fragment, JSXElementConstructor, PropsWithChildren } from "react";

type Provider<T> = JSXElementConstructor<PropsWithChildren<T>>;
export const provide = <T extends object>(provider: Provider<T>, props: T = {} as T): [Provider<T>, {}] => [
    provider,
    props,
];
interface ProviderComposerProps<T = any> {
    providers: Array<[Provider<T>, T]>;
}
const ProviderComposer = ({ providers = [], children }: PropsWithChildren<ProviderComposerProps>) => {
    return (
        <Fragment>
            {providers.reduceRight((reactNode, compose) => {
                const [Provider, props] = compose;
                return <Provider {...props}>{reactNode}</Provider>;
            }, children)}
        </Fragment>
    );
};

export default ProviderComposer;
